<div class="faq-modal-container">
  <!-- Header Bar -->
  <div class="faq-header">
    <div class="faq-header-top">
      <div class="faq-title-area">
        <ion-icon name="help-circle" class="faq-header-icon"></ion-icon>
        <div>
          <h2>Help & Frequently Asked Questions</h2>
          <p class="subtitle">Quick guides and answers across CSO Cockpit modules</p>
        </div>
      </div>
      <ion-button fill="clear" class="close-btn" (click)="dismiss()" aria-label="Close FAQ dialog">
        <ion-icon slot="icon-only" name="close-outline"></ion-icon>
      </ion-button>
    </div>

    <!-- Section Pills / Switcher -->
    <div class="section-pills" role="tablist">
      @for (sec of sections; track sec.id) {
        <button
          type="button"
          role="tab"
          [attr.aria-selected]="activeSectionId() === sec.id"
          class="pill-btn"
          [class.pill-btn--active]="activeSectionId() === sec.id"
          (click)="selectSection(sec.id)"
        >
          <ion-icon [name]="sec.icon"></ion-icon>
          <span>{{ sec.shortTitle }}</span>
          <span class="pill-badge">{{ getItemCount(sec.id) }}</span>
        </button>
      }
    </div>

    <!-- Live Search -->
    <div class="faq-search-wrapper">
      <div class="search-box">
        <ion-icon name="search-outline"></ion-icon>
        <input
          type="text"
          [value]="searchQuery()"
          (input)="onSearchInput($event)"
          placeholder="Search questions or keywords..."
          aria-label="Search FAQ"
        />
        @if (searchQuery()) {
          <button type="button" (click)="clearSearch()" class="clear-search-btn" aria-label="Clear search">
            <ion-icon name="close-circle"></ion-icon>
          </button>
        }
      </div>
      @if (searchQuery()) {
        <div class="search-meta">
          Found {{ filteredItems().length }} question{{ filteredItems().length === 1 ? '' : 's' }} in {{ activeSection().shortTitle }}
        </div>
      }
    </div>
  </div>

  <!-- Scrollable Accordion Content -->
  <ion-content class="faq-content">
    <div class="faq-body-inner">
      <div class="section-banner">
        <div class="banner-title-row">
          <ion-icon [name]="activeSection().icon"></ion-icon>
          <h3>{{ activeSection().title }}</h3>
        </div>
        <p>{{ activeSection().description }}</p>
      </div>

      <!-- Questions List -->
      @if (filteredItems().length > 0) {
        <ion-accordion-group [multiple]="true">
          @for (item of filteredItems(); track item.id) {
            <ion-accordion [value]="item.id">
              <ion-item slot="header" lines="none" class="faq-accordion-header">
                <ion-icon name="help-outline" slot="start" class="q-icon"></ion-icon>
                <ion-label class="q-text">{{ item.question }}</ion-label>
              </ion-item>
              <div class="faq-accordion-body" slot="content">
                <p [innerHTML]="item.answer"></p>
                @if (item.tags && item.tags.length > 0) {
                  <div class="tag-row">
                    @for (tag of item.tags; track tag) {
                      <span class="tag-chip">#{{ tag }}</span>
                    }
                  </div>
                }
              </div>
            </ion-accordion>
          }
        </ion-accordion-group>
      } @else {
        <!-- Empty Search State -->
        <div class="faq-empty-state">
          <ion-icon name="search-outline"></ion-icon>
          <h4>No matching questions</h4>
          <p>We couldn't find any questions matching "<b>{{ searchQuery() }}</b>" in {{ activeSection().shortTitle }}.</p>
          <ion-button fill="outline" size="small" (click)="clearSearch()">
            Clear search
          </ion-button>
        </div>
      }
    </div>
  </ion-content>

  <!-- Footer Actions -->
  <div class="faq-footer">
    <div class="footer-manual-hint">
      <ion-icon name="document-text-outline"></ion-icon>
      <span>Need more details?</span>
      <a href="javascript:void(0)" (click)="downloadManual()">Download Complete User Manual (PDF)</a>
    </div>
    <ion-button fill="solid" class="close-footer-btn" size="small" (click)="dismiss()">
      Close
    </ion-button>
  </div>
</div>
